import "./App.css";
import { QueryClient, QueryClientProvider } from "react-query";
import TotalAgentData from "./TotalAgentData";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <h1>M-Mobility</h1>
        <TotalAgentData />
      </div>
    </QueryClientProvider>
  );
};

export default App;
